
import { MultiPolygon, PolyCoords } from '../../../features/typescript/MapShapes';
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import Button from '../../core/components/Generics/Button.vue';
import RequestDialog from '../../core/components/Generics/RequestDialog.vue';
import { ItemServices } from '../../core/api/ItemServices';
import { ColorsList } from '../../core/utils/type-colors';
import { isValidRedirectUrl } from '../../helpers/is-valid-redirect-url';
@Component({
  components: {
    Button,
    RequestDialog
  }
})
export default class SendItemDialog extends Vue {
  @Prop({ default: () => [] }) polygonCoords!: PolyCoords;
  @Prop({ default: '' }) submitTooltip: string;
  @Prop({default: false}) isReadOnly: boolean;
  @Prop({default: false}) polygonReallyModified: boolean;
  orangeColor: string = ColorsList.mid_orange;
  logoSmartwayWhite: string = require('../../../../assets/logo_smartway_blue.png');
  smartwayUrl: string = 'https://onsmartway.com';
  dialog = false;
  loading = false;
  success = false;
  error = false;
  dialogTitle = 'Guardando...';
  successMessage = 'Guardado correctamente.';
  errorMessage = 'Ocurrió un error.';
  errorDescription: string = '';

  existsCoordsForPolygon() {
    return this.polygonCoords && this.polygonCoords.length > 0;
  }

  get canSubmit(){
    return this.submitTooltip === '';
  }

  clickSaveItem() {
    if(this.isReadOnly){
      this.showMessage('Usted no cuenta con los permisos necesarios para modificar el item', 'error')
      return
    }

    if(!this.canSubmit){
      this.showMessage(this.submitTooltip, 'error');
      return;
    }
    
    return this.sendItemToBackend();
  }

  @Emit()
  redirectAction(newUrl: string | null){}

  async sendItemToBackend() {
    this.dialog = true;
    this.loading = true;
    this.success = false;
    this.error = false;
    this.dialogTitle = 'Guardando...';
    this.errorDescription = '';
    let self = this;
    ItemServices.addPolygonToItem(
      { 
        polygon: this.polygonCoords,
        updated: this.polygonReallyModified
      }
    ).then((response) => {
      let redirectUrl = response.redirect_url || null;
      this.success = true;
      this.dialogTitle = this.successMessage;

      if (isValidRedirectUrl(redirectUrl)) {
        self.redirectAction(redirectUrl);
      } else {
        this.showMessage(
          'La URL de redirección no es válida.',
          'error'
        );
      }
    }).catch((error) => {
      this.error = true;
      this.errorDescription = error && error.response && error.response.data && error.response.data.message ? error.response.data.message : '';
      this.dialogTitle = this.errorMessage;
    }).finally(() => {
      this.loading = false;
    });
  }

  closeItem(){
    if(window.confirm('¿Desea salir del Item?')) {
        this.redirectAction(null);
    }
  }

  closeDialog() {
    this.dialog = false;
    this.resetDialog();
  }

  resetDialog() {
    this.loading = false;
    this.success = false;
    this.error = false;
    this.dialogTitle = '';
  }

  @Emit()
  showMessage(message: string, color: string) {}
}
